import { useLocation, Navigate, Outlet } from "react-router-dom";
// import useAuth from "./useAuth";

const PrivateRoute = () => {
    // const { auth } = useAuth();
      const token = localStorage.getItem("jwtToken");

    const location = useLocation();
    return (
        token ?
        <Outlet /> : 
        <Navigate to="/" state={{from: location}} replace />
    );
}

export default PrivateRoute;